import {clsx} from 'clsx'

import unreadStyles from './UnreadBorder.module.css'

/**
 * Shared unread treatment for dashboard list rows so issues and pull requests
 * render an identical read indicator in the mixed list.
 *
 * A row's unread state has two parts:
 *  1. a left accent border, applied via a className on the `ListItem`, and
 *  2. an `sr-only` "Unread" marker rendered inside the row's leading content.
 *
 * Both issue and pull-request rows consume these helpers so the behavior stays
 * in one place instead of being copied per row component.
 */

/**
 * Returns the row className with the unread accent border appended when the row
 * is unread. Extra classNames are merged so callers can keep their own row
 * styling (e.g. compact vs default).
 */
export function unreadRowClassName(isRead: boolean, ...classNames: Array<string | undefined | false>): string {
  return clsx(...classNames, !isRead && unreadStyles.unreadBorder)
}

/**
 * Screen-reader-only "Unread" marker. Render inside `ListItemLeadingContent`.
 * Renders nothing when the row has been read.
 */
export function UnreadRowLabel({isRead}: {isRead: boolean}) {
  return isRead ? null : <span className="sr-only">Unread</span>
}
